module.exports = __webpack_public_path__ + "static/media/Cafe_5.48cbd580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_5.png
// module id = 1323
// module chunks = 3